import React from 'react';

const NotFound = () => (
 <div>Sidan kunde inte hittas</div>
);

export default NotFound;
